module.exports = __webpack_public_path__ + "img/EDC5000DQ_1-1.80422a98.png";